import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // Show popup as soon as the component loads
    setTimeout(() => {
      const popup = document.getElementById('popupModal');
      if (popup) {
        popup.style.display = 'flex';
      }
    }, 0);
  }

  closePopup(): void {
    const popup = document.getElementById('popupModal');
    if (popup) {
      popup.style.display = 'none';
    }
  }

  getYear() {
    return moment().format('YYYY');
  }
}
